const sizesContainer = document.querySelector('.content-tallas');    
orderSizes(sizesContainer);

// Ordenamiento de tallas: 
function orderSizes(selector) {
  
  if (!selector) return;

  const sizes = Array.from(selector.querySelectorAll('.container-item-talla'));

  sizes.sort((a, b) => {
    // Obtenemos los strings: "H41-M42", "H41-M41", etc.
    const valorA = a.dataset.variantOption;
    const valorB = b.dataset.variantOption;

    // localeCompare con 'numeric: true' hace que "H2" vaya antes que "H10"
    return valorA.localeCompare(valorB, undefined, { numeric: true, sensitivity: 'base' });
  });  

  sizes.forEach(el => selector.appendChild(el));
  
} 

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
 
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Guard clause: ensure sliderItemsToShow exists and has elements
    if (!this.sliderItemsToShow || this.sliderItemsToShow.length === 0) {
      return;
    }

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      // Only dispatch event if currentElement exists
      if (currentElement) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: currentElement
        }}));
      }
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
      // this.prevButton.parentElement.classList.add('self-hide');
    } else {
      this.prevButton.removeAttribute('disabled');
      // this.prevButton.parentElement.classList.remove('self-hide');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
      // this.nextButton.parentElement.classList.add('self-hide');
    } else {
      this.nextButton.removeAttribute('disabled');
      // this.nextButton.parentElement.classList.remove('self-hide');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.isUpdating = false; // Flag to prevent infinite recursion
    this.addEventListener('change', this.onVariantChange);

    /** */
    const variantInfo = this.querySelector('.variant-info')
    // console.log('VARIANT INFO', this.querySelector('.variant-info'));
    if(variantInfo != null){
      this.getVariantInfo(variantInfo); 
    }
    // this.setPickUpButton();
    /** */
  }

 
  onVariantChange() {
    // Prevent infinite recursion
    if (this.isUpdating) return;    
    this.isUpdating = true;
    
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    // console.log(this.currentVariant);
    


    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      /** */
      // console.log('Cambió de variante.');
      // console.log(this.currentVariant.id);
      // console.log(this.querySelectorAll('.container-item-talla').dataset.productId);
      
      // Supongamos que 'this' se refiere al contexto actual donde se llama la función, por ejemplo, dentro de un método de clase.
      const containerItems = Array.from(this.querySelectorAll('.container-item-talla'));
      // console.log(containerItems);
      
      const variant = containerItems.find(item => item.dataset.variantId == this.currentVariant.id);
      
      console.log('VARIANTE QUE ENVIO: ',variant);
      
      this.getVariantInfo(variant);    
      /** */
    }

    // Reset flag to allow future updates
    this.isUpdating = false;
    
  }

  /** Métodos Propios */

  formatToCOP(amount) {
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(amount);
  }
  
  async getVariantInfo(variant){

    // Configuración de credenciales: 
    const accessToken = "2c137203d90c2b306f650a600486531b";
    const endpoint = "https://crocs-shop-colombia.myshopify.com/api/2024-10/graphql.json";

    // console.log('******************************************');
    // console.log('Item: ', this.querySelector('.container-item-talla'));

    const variantValue = variant.querySelector('.input-talla')?.value ? variant.querySelector('.input-talla').value : 'Default Title';
    // console.log('Valor: ', variantValue);
    
    
    // Obtener el contenedor padre
    // const parentContainer = this.querySelector('.container-item-talla');
    const parentContainer = variant;
    let productId = "";


    console.log('Contenedor padre: ', parentContainer);
    

    
    if (parentContainer) {
      // console.log('Contenedor padre:', parentContainer);
      // console.log('Data SKU:', parentContainer.dataset.sku);
      // console.log('Variant ID:', parentContainer.dataset.variantId);
      // console.log('Product ID:', parentContainer.dataset.productId);
      productId = `gid://shopify/Product/${parentContainer.dataset.productId}`;

      // console.log('DP → PDP - Product ID: ', productId);
      
      // Llamada a la API para obtener información del producto (opcional)
      try {
        const productInfo = await this.fetchProduct(accessToken, endpoint, productId);
        console.log('DP → PDP - Product Info: ', productInfo);
        if(productInfo && productInfo.data?.product != null){

          const variantNodes = productInfo.data.product.variants?.nodes ?? [];
          console.log('Variant Nodes: ', variantNodes);

          if(variantNodes.length > 0) {
            variantNodes.forEach(node => {
              console.log('Nodo: ', node);
              if (node.locationsInventory?.value != null) {
                let locationsInventory = [];
                try {
                  locationsInventory = JSON.parse(node.locationsInventory.value)?.inventory?.locations ?? [];
                } catch (parseError) {
                  console.warn('Error parsing locationsInventory JSON:', parseError);
                }
                console.log('Locations Inventory JSON', locationsInventory);
                if (Array.isArray(locationsInventory)) {
                  locationsInventory.forEach(location => {
                    if (location?.name === '82-85 Avenida Carrera 19' || location?.name === 'CEDI IX Comercio Colombia San Diego') {
                      let warehouse = {
                        available: false,
                        quantityAvailable: Number(location.stock),
                        location: {
                          name: location.name
                        }
                      }
                      if (location.stock > 0) {
                        warehouse.available = true;
                        warehouse.quantityAvailable = Number(location.stock);
                      }
                      if (!Array.isArray(node.storeAvailability?.nodes)) {
                        if (node.storeAvailability == null) node.storeAvailability = {};
                        node.storeAvailability.nodes = [];
                      }
                      node.storeAvailability.nodes.push(warehouse);
                    }
                  })
                }
              }

              if(Array.isArray(node.selectedOptions) && node.selectedOptions.length > 0){
                // console.log(node.selectedOptions[0]);
                const foundItem = node.selectedOptions.some(item => item.value === variantValue); // Conciden el ID de la variante con el valor del input.
                const foundValue = node.selectedOptions.find(item => item.value === variantValue);
                // console.log(foundValue);
                if(foundItem){
                  // console.log('Found Item: ', foundItem);
                  // console.log('Found Value: ', foundValue);
                  // console.log('Node: ', node); // Varian
                  if(node.availableForSale){
                    const storeAvailabilityNodes = node.storeAvailability.nodes;
                    console.log('SAN: ', storeAvailabilityNodes);
                    // if(storeAvailabilityNodes.length > 0){
                      const availableStores = storeAvailabilityNodes.filter(store => store.available === true);
                      // console.log('AVAIStores ', availableStores);
                      const product = productInfo.data.product;
                      const variant = node;
                      this.setAvailabilityIndicators(availableStores, product, variant); //Stores - Product - Variant
                    // }

                  }
                }
              }
            });
          }

        }
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    }
  }


  async fetchProduct (accessToken, endpoint, productId) {

    const query = `
      query getProductById($id: ID!) {
        product(id: $id) {
          id
          totalInventory
          title
          featuredImage {
              url
          }
          variants (first: 250) {
            nodes {
              id
              sku
              availableForSale
              quantityAvailable                        
              warehouseInventory: metafield(namespace: "product_variant", key: "warehouse_inventory_quantity") {
                  namespace
                  key
                  value
                }
                locationsInventory: metafield(namespace: "locations", key: "inventory") {
                  namespace
                  key
                  value
                }
              price {
                amount
              }                
              compareAtPrice {
                amount
              }
              selectedOptions {
                name
                value
              }
              requiresShipping
              storeAvailability (first: 250) {
                nodes {                  
                  available
                  quantityAvailable
                  location {
                    name
                    address {
                      city      
                      formatted                
                    }                    
                  }
                }
              }
            }
          }
        }
      }
    `;

    const variables = {
      id: String(productId)
    };

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken
      },
      body: JSON.stringify({ query, variables })
    });

    const productInfo = await response.json();

    return productInfo;
  }

  async setAvailabilityIndicators(stores, productInfo = {}, variantInfo = {}){
    // console.log('----------------------------------------------------------------');
    console.log('Habilitando Indicadores...');
    // console.log('Indicadores - Tiendas: ', stores);
    // console.log('Indicadores - Información del producto: ', productInfo);
    // console.log('Indicadores - Información de la variante: ', variantInfo);   
    
    /* Tiendas de envíos */
    const storesToShipping = [ 
      "82-85 Avenida Carrera 19", 
      "CEDI IX Comercio Colombia San Diego",
      "Titan Plaza",
      "Gran Estación Crocs",
      "Chipichape Crocs",
      "La Serrezuela",
      "Jardín Plaza Cúcuta",
      "El Tesoro Medellín",
      "Alamedas",

      // "Plaza Central Crocs",
      // "El Edén Crocs",
      // "Único Outlet Bucaramanga Crocs",
      "Fontanar",
      "Buenavista Crocs",

      "Jardin Plaza Cali",
      // "Mall Plaza Cali Crocs",
      "Mall Plaza Cartagena Crocs",
      "Zona T Crocs",
      "Parque Arboleda Pereira"
    ];

    const storesToPickup = [
      "Titan Plaza",
      "Gran Estación Crocs",
      // "Plaza Central Crocs",
      "Zona T Crocs",
      // "El Edén Crocs", 
      // "Único Outlet Bucaramanga Crocs",
      "Jardin Plaza Cali",
      // "Mall Plaza Cali Crocs",
      "Chipichape Crocs",
      "La Serrezuela", 
      "Mall Plaza Cartagena Crocs",
      "Fontanar",
      "Jardín Plaza Cúcuta",
      "El Tesoro Medellín", 
      "Alamedas",
      "Parque Arboleda Pereira",
      // "Mayorca Sabaneta",
      "Buenavista Crocs"
    ]
    
    let shippingStores = stores.filter(store => (store.available === true && storesToShipping.includes(store.location.name))); // Bodega - Tiendas de Ship From Store

  

    // const pickupStores = stores.filter(store => (store.available === true && storesToPickup.includes(store.location.name))); // Pickups
    const pickupStores = stores.filter(store => (store.available === true && storesToPickup.includes(store.location.name))); // Pickups
  
    console.log('Tiendas de Envíos: ', shippingStores);
    console.log('Tiendas de Retiro: ', pickupStores);

    /* Indicadores de disponibilidad */
    const options = document.querySelectorAll('.pickup-store__option');   

    if (options) {
      options.forEach((option, index) => { 
        const isShip = option.dataset.storeType === 'ship';
        const isPick = option.dataset.storeType === 'pick';

        // console.log('¿Es shipping? ', isShip);
        // console.log('¿Es pickup? ', isPick);        
    
        // Condiciones para habilitar la opción
        let shouldEnable =
          (shippingStores.length > 0 && pickupStores.length === 0 && isShip) || // Solo shipping
          (shippingStores.length === 0 && pickupStores.length > 0 && isPick) || // Solo pickup
          (shippingStores.length > 0 && pickupStores.length > 0 && (isShip || isPick)); // Ambos

        // console.log('¿Debe habilitarse? ', shouldEnable);
        // console.log('Indicador: ', option);

        /* Si no hay tiendas de envíos */
        /* 1. Si no hay ningun tipo de tienda pero está habilitado quiere decir que tiene Envio */
        /* 2. Si tiene tiendas de ship from store habilitadas, quiere decir que tiene Envio */
        // console.log('Condición 1: ', shippingStores.length === 0 && pickupStores.length === 0 && isShip);
        // console.log('Condición 2: ', shippingStores.length === 0 && pickupStores.length === 0 && isShip);
        
        // // if (shippingStores.length === 0 && pickupStores.length === 0 && isShip) {
        // if ((shippingStores.length === 0 && (pickupStores.length === 0 || pickupStores.length > 0) && isShip && variantInfo.availableForSale)) {
        //   shouldEnable = variantInfo.availableForSale;
        // } else if (shippingStores.length === 0 && isShip) {
        //   shouldEnable = variantInfo.availableForSale && pickupStores.some(store => storesToShipping.includes(store.location.name));
        // }

        // shouldEnable = true;
           
        const info = option.querySelector('.pickup-store__option-info');
        const type = option.querySelector('.pickup-store__option-type');      
    
        const addToCartButton = document.getElementById('add-to-cart-btn');
        
        /* Habilitar o deshabilitar la opción según las condiciones */
        if (shouldEnable) {
          
          option.classList.remove('pickup-store__option--disabled');

          if(isPick){  

            if(info){ info.textContent = 'Disponible'; }

            if(type){
              type.textContent = `Retiro en Tienda (${pickupStores.length})`;
              if (!type.classList.contains('pickup-store__option-type--available')) {
                type.classList.add('pickup-store__option-type--available');
              }                
            }          
       
            this.setPickupInfo(shouldEnable, pickupStores, option, productInfo, variantInfo, true);           
            this.setPickupButton(variantInfo);
            this.enablePickupButton(true);

            option.addEventListener('click', (event) => {
              const modal = document.getElementById('pickup-store-modal');
              modal.style.display = 'flex';         
            });
          }

          if(isShip){

            if(info){ info.textContent = 'Disponible'; }

            if(addToCartButton){
              addToCartButton.style.display = 'block';
            }
          }

        } else {
          option.classList.add('pickup-store__option--disabled');         

          if(isPick){    

            if (type.classList.contains('pickup-store__option-type--available')) {
              type.classList.remove('pickup-store__option-type--available');
              this.enablePickupButton(false);              
            }

            if(info){ info.textContent = 'No Disponible'; }

            if(type){
              type.textContent = `Retiro en Tienda`;
            }
           
          }

          if(isShip){

            if(addToCartButton){
              addToCartButton.disabled = true;
              addToCartButton.style.display = 'none'; 
            }   

            if(info){ info.textContent = 'No Disponible'; }
            
          }
        }
      });
    }

    //  console.log('----------------------------------------------------------------');

  }


  setPickupInfo(avaible, stores, option = null, productInfo = {}, variantInfo = {}, activateControls = false){

    // console.log('Set Pickup Info:');
    // console.log('Avaible: ', avaible);
    // console.log('Stores: ', stores);
    // console.log('Option: ', option);
    // console.log('Product Info: ', productInfo);    
    // console.log('Variant Info: ', variantInfo);

    if(avaible && stores && option){
      // option.addEventListener('click', (event)=> {
      
        const modal = document.getElementById('pickup-store-modal');

        if(modal && variantInfo){ 
          

          const selectorsPrice = document.querySelectorAll('#pickup-store-modal .pickup-store-modal__product-price, #pickup-store-modal .pickup-store-modal__product-price-sale__saleprice');
          const selectorProductSale = document.querySelector('.pickup-store-modal__product-price-sale');
          const selectorOldPrice = document.querySelector('#pickup-store-modal .pickup-store-modal__product-price-sale__oldprice s');
          const selectorSku = document.querySelector('#pickup-store-modal .pickup-store-modal__product-sku');
          const selectorVariantName = document.querySelector('#pickup-store-modal .pickup-store-modal__product-variant-name');
          const selectorVariantValue = document.querySelector('#pickup-store-modal .pickup-store-modal__product-variant-value');

          // console.log(selectorsPrice);          

          // const productImage = variantInfo.
          const variantPrice = variantInfo.price.amount;
          const variantCompareAtPrice = variantInfo.compareAtPrice.amount;
          const variantSku = variantInfo.sku;
          const variantName = variantInfo.selectedOptions[0].name;
          // const variantValue = variantInfo.selectedOptions[0].value; 
          const variantValue = variantInfo.sku.split("-").pop(); 

          // console.log(parseFloat(variantInfo.price.amount) !== parseFloat(variantInfo.compareAtPrice.amount));
          // console.log(parseFloat(variantInfo.price.amount));
          // console.log(parseFloat(variantInfo.compareAtPrice.amount));          
    
          // console.log(selectorProductSale);
          // console.log(selectorProductSale.classList);
          // console.log(selectorProductSale.classList.contains('pickup-store-modal__product-price--hidden'));
                    
          selectorsPrice.forEach(selector => {
            
            if(parseFloat(variantPrice) != parseFloat(variantCompareAtPrice) && selectorProductSale){
              if(selectorProductSale.classList.contains('pickup-store-modal__product-price--hidden')){
                // console.log('LA CONTIENE');
             
                if(selector){
                  selector.style.display = 'none';
                  selector.textContent = "";
                  selector.textContent = this.formatToCOP(variantPrice);
                } 
                selectorProductSale.style.display = 'flex';
                selectorProductSale.classList.remove('pickup-store-modal__product-price--hidden');
                // console.log(selectorProductSale);
              }            
            } else {
              if(!selector){
                selector.style.display = 'flex';

              }
              selector.textContent = "";
             selector.textContent = this.formatToCOP(variantPrice);
            }
          });

        
          if(selectorOldPrice){
            selectorOldPrice.textContent = "";
            selectorOldPrice.textContent = this.formatToCOP(variantInfo.compareAtPrice.amount);
          }

          if(selectorSku){
            selectorSku.textContent = "";
            selectorSku.textContent = variantSku;
          }

          if(selectorVariantName){
            selectorVariantName.textContent = "";
            selectorVariantName.textContent = variantName;
          }

          if(selectorVariantValue){
            selectorVariantValue.textContent = "";
            selectorVariantValue.textContent = variantValue;
          }

          
          const selectorStores = document.querySelector('.pickup-store-modal__stores');

          if(stores.length > 0 && selectorStores){
            const groupByCity = (data) => {
              const grouped = data.reduce((acc, item) => {
                  const city = item.location.address.city;
                  if (!acc[city]) {
                      acc[city] = [];
                  }
                  acc[city].push(item);
                  return acc;
              }, {});
          
              // Convertir el objeto agrupado en un array de objetos
              return Object.entries(grouped).map(([city, stores]) => ({
                  city,
                  stores
              }));
          };


            // Organizar la respuesta
            const groupedStores = groupByCity(stores);
            // console.log('GDATA: ', groupedStores);
            
            selectorStores.innerHTML = '';

            let html = "";
            let inputHtml = "";
            
            groupedStores.forEach((group, index) => {
              // console.log(group);

              if(group.stores.length > 0){

                const storesHTML = group.stores
                .map(
                  (store, storeIndex) => {
                    if(activateControls){
                      return `
                        <li class="pickup-store-modal__store-item">
                          <label class="pickup-store-modal__store-label" for="store-${index}-${storeIndex}">
                            <input class="pickup-store-modal__store-input" type="radio" name="store" value="${store.location.name}">
                          </label>
                          <div class="pickup-store-modal__store-info">
                            <span class="pickup-store-modal__store-message">
                            <svg class="pickup-store-modal__store-message-icon" aria-hidden="true" focusable="false" role="presentation" class="icon icon-in-stock" viewBox="0 0 12 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 9.707l-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z" fill="rgb(0, 115, 11)"></path></svg>
                            Retiro disponible, normalmente está listo en 24 horas
                            </span>
                            <!-- span class="pickup-store-modal__store-address pickup-store-modal__store-address--city">${store.location.address.city}</span -->
                            <span class="pickup-store-modal__store-location-name">${store.location.name}</span>
                            <span class="pickup-store-modal__store-address">${store.location.address.formatted.map((address) => address).join('<br>')}</span>
                          </div>
                        </li>
                      `
                    } else {
                      return`
                        <li class="pickup-store-modal__store-item pickup-store-modal__store-item--spaced">                        
                          <div class="pickup-store-modal__store-info">
                            <span class="pickup-store-modal__store-message">
                            <svg class="pickup-store-modal__store-message-icon" aria-hidden="true" focusable="false" role="presentation" class="icon icon-in-stock" viewBox="0 0 12 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 9.707l-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z" fill="rgb(0, 115, 11)"></path></svg>
                            Retiro disponible, normalmente está listo en 24 horas
                            </span>
                            <!-- span class="pickup-store-modal__store-address pickup-store-modal__store-address--city">${store.location.address.city}</span -->
                            <span class="pickup-store-modal__store-location-name">${store.location.name}</span>
                            <span class="pickup-store-modal__store-address">${store.location.address.formatted.map((address) => address).join('<br>')}</span>
                          </div>
                        </li>
                      `
                    }
                  }
                )
                .join(""); // Unir el array en una sola cadena
          
                // Construir el HTML del grupo de tiendas
                if(activateControls){ 
                  html += `
                  <div class="pickup-store-modal__store">
                    <details class="pickup-store-modal__store-details" ${(index == 0) ? 'open' : ''}>
                      <summary class="pickup-store-modal__store-city" data-store-index="${index}">${group.city}</summary>
                      <ul class="pickup-store-modal__store-list">
                        ${storesHTML}
                      </ul>
                    </details>
                  </div>
                `;
                } else {
                  html += `
                  <div class="pickup-store-modal__store">
                    <details class="pickup-store-modal__store-details pickup-store-modal__store-details--unpointer" ${(index == 0) ? 'open' : ''}>
                      <summary class="pickup-store-modal__store-city" data-store-index="${index}">${group.city}</summary>
                      <ul class="pickup-store-modal__store-list">
                        ${storesHTML}
                      </ul>
                    </details>
                  </div>
                `;
                }

                if(activateControls){
                  const button = document.querySelector('.pickup-store-modal__cart-button');
                  if(button){
                    button.style.display = 'inline-flex';
                  }
                }
             
              }           
            });

            selectorStores.innerHTML = '';

           selectorStores.insertAdjacentHTML('beforeend', html);  

            this.addToogleToStores();

          }
        }       
     
    }
  }

  /**/

  // Cierra los summary de tiendas
  addToogleToStores = () => {
    const detailsElements = document.querySelectorAll('.pickup-store-modal__store-details');

    detailsElements.forEach(details => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          detailsElements.forEach(otherDetails => {
            if (otherDetails !== details && otherDetails.open) {
              otherDetails.open = false;
            }
          });
        }
      });
    });
  }

  /** Show Modal */
  showModal(variantInfo = {}) {
    // console.log('Show Modal');

    const alertMessage = document.querySelector('.pickup-store-modal__alert');
    const button = document.querySelector('.pickup-store-modal__cart-button');
    const label = document.querySelectorAll('.pickup-store-modal__store-label');    
    
    const modal = document.getElementById('pickup-store-modal');
    const body = document.querySelector('body');

    // console.log('Body', body);
    

    if (modal) {
      if(button){
        // button.style.display = 'none';
      }
      if(label){
        label.forEach(element => {
          // element.style.display = 'none';
        });
      }
      modal.style.display = 'flex'; 
      body.style.overflow = 'hidden';
    }

    if(alertMessage){
      // alertMessage.style.display = 'none';
    }

    /**------------------------------------------- */
    // Quitar si no se necesita, para deshabilitar opciones enel indicador. 
    this.setAddToCartButtonClick(variantInfo);
    
 
    if (modal) {
      /** Configura el click de la lista de items */
      this.setModalOptionsListClick(variantInfo); 
      modal.style.display = 'flex'; 
      body.style.overflow = 'hidden';
    }

    /**------------------------------------------- */

  }

  /** Show Modal With Options */
  showModalWithOptions(variantInfo = {}) {
    // console.log('Show Modal With Options');
    // console.log(variantInfo);    
    
    const alertMessage = document.querySelector('.pickup-store-modal__alert');
    const addToCartButton = document.querySelector('.pickup-store-modal__cart-button');
    const label = document.querySelectorAll('.pickup-store-modal__store-label');    

    const body = document.querySelector('body');

    /** Muestra el botón y lo deshabilita */
    if(addToCartButton) {
      if(addToCartButton.disabled == false) {
        addToCartButton.disabled = true;
      }
      addToCartButton.style.display = 'flex';     
    }
    
    if(label){
      label.forEach(element => {
        element.style.display = 'flex';
        // element.addEventListener('change', (event) => {
        //   const selectedValue = event.target.value;
        //   console.log('Valor seleccionado:', selectedValue);
        //   if(button && button.disabled == true){
        //     button.disabled = false;
        //   }
        // });
      });
    }

    if(alertMessage){
      alertMessage.style.display = 'block';
    }

    
    this.setAddToCartButtonClick(variantInfo);
    
    const modal = document.getElementById('pickup-store-modal');
    if (modal) {
      /** Configura el click de la lista de items */
      this.setModalOptionsListClick(variantInfo); 
      modal.style.display = 'flex'; 
      body.style.overflow = 'hidden';
    }
  }

  /** Paso: 1 - Lista de items */
  setModalOptionsListClick(variantInfo = {}) {
    const storeItems = document.querySelectorAll('.pickup-store-modal__store-item');
   
    if (!this.boundEnableInputStoreListFunctions) {
      this.boundEnableInputStoreListFunctions = [];
    }
  
    
    
    if(storeItems.length > 0){
      storeItems.forEach((storeItem, index) => {
        if (this.boundEnableInputStoreListFunctions[index]) {
          storeItem.removeEventListener('click', this.boundEnableInputStoreListFunctions[index]);
        }
  
        // Crea una nueva función enlazada y guárdala en el arreglo
        this.boundEnableInputStoreListFunctions[index] = this.enableInputStoreList.bind(this, storeItem, variantInfo);
  
        // Agrega el nuevo evento
        storeItem.addEventListener('click', this.boundEnableInputStoreListFunctions[index]);
        // storeItem.removeEventListener('click', this.enableInputStoreList);
        // storeItem.addEventListener('click', this.enableInputStoreList.bind(storeItem, variantInfo));
      });
      // console.log('Store Items: ',storeItems);
    }    
  }

  /** Paso: 2 - Lista de items */
  enableInputStoreList(storeItem = {},variantInfo = {}){

  
    // console.log('Store Item:', storeItem);
    // console.log('Variant Info:', variantInfo);
    
    
    const addToCartButton = document.querySelector('.pickup-store-modal__cart-button');
    const input = storeItem.querySelector('.pickup-store-modal__store-label .pickup-store-modal__store-input');

    /** Deshabilita el botón */
    if(addToCartButton && addToCartButton.disabled == false){
      addToCartButton.disabled = true;
    }

    if (input) {
      // console.log(input);    
      // console.log(input.value);
      input.checked = true;
      if(addToCartButton && addToCartButton.disabled == true){
        addToCartButton.disabled = false;
      }
    } 

    // console.log('Option'); 
    // console.log(variantInfo);
    
  }

   /** Paso: 3 - Lista de items */
  setAddToCartButtonClick(variantInfo = {}){
    
    const buttonContainer = document.querySelector('.pickup-store-modal__button-container');
 

    if(buttonContainer){

      let addToCartButton = document.querySelector('.pickup-store-modal__cart-button');
      if(addToCartButton){
        addToCartButton.remove();
      }

      const button = document.createElement('button');
      button.id = 'pickup-button-modal';
      button.className = 'sys-button sys-button--fill-primary pickup-store-modal__cart-button';
      button.type = 'button';
      button.style.display = 'flex';
      button.textContent = 'Agregar al carrito';
      button.disabled = true;

      // console.log('BOTÓN: ', button);

      
      buttonContainer.insertAdjacentHTML('beforeend', button.outerHTML);
      
      addToCartButton = document.querySelector('.pickup-store-modal__cart-button');



      if(addToCartButton){
        addToCartButton.removeEventListener('click', this.addProductVariant);
        addToCartButton.addEventListener('click', this.addProductVariant.bind(this, variantInfo));
      }
  
   
      // console.log('Información de la variante: ', variantInfo);
    }  
  }

   /** Paso:4 - Lista de items  */
  addProductVariant(variantInfo = {}){ 
    // console.log('Test');
    // console.log(this);


    // localStorage.setItem('cartOptionsConfiguration', JSON.stringify(
    //   { 
    //     option: radio.value,
    //     children: [],
    //     keys: []
    //   }
    // ));
    


    const quantityInput = document.querySelector('.quantity__input') ? document.querySelector('.quantity__input').value : 0;  
    const storeInputs = document.querySelectorAll('.pickup-store-modal__store-input');

    // console.log('Cantidad del producto: ', quantityInput);
    // console.log('Store Inputs: ', storeInputs);
    
    let storeSelected = null;
    
    if (storeInputs.length > 0) {
      // Usamos Array.from para convertir el NodeList en un arreglo y poder usar find
      storeInputs.forEach(store => {
        if (store.checked) {
          storeSelected = store.value;
        }
      });
    }

    // console.log('Tienda Seleccionada: ', storeSelected);


      
    // console.log('variantId, variantInfo, storeSelected, formData');
    // console.log(variantInfo);
    // console.log(storeSelected);

    if(variantInfo, storeSelected !== null){
      
      const variantId = Number(variantInfo.id.split('/').pop());
      // console.log('Variant ID: ', variantId);     
      
      const formData = {
        'items': [{
          'id': variantId,
          'quantity': quantityInput,
          'properties': {
            Talla: variantInfo.value,
            // unique_id: Date.now().toString(), // Identificador único (marca de tiempo)
            store_selected: storeSelected 
          }          
        }]
      }; 

      // console.log('Form Data: ', formData);
      
      // let virtualCart = {
      //   'items': [{
      //     'variant_id': variantId,
      //     // 'quantity': quantityInput,
      //     'store': storeSelected,
      //     'variant': variantInfo,
      //     'quantity': Number(quantityInput),
      //     // 'unique_id:': Date.now().toString()
      //   }]
      // };

      // console.log('Virtual Cart: ', virtualCart);
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        // console.log('Response: ', response);

        const modal = document.getElementById('pickup-store-modal');
        const body = document.querySelector('body');
        if (modal) {
          modal.style.display = 'none';
          body.style.overflow = 'auto';
        }


        // Obtener el carrito existente desde localStorage
        // let existingCart = localStorage.getItem('virtualCart');

        // if (existingCart) {
        //   // Si ya existe un carrito, convertirlo de JSON a objeto
        //   existingCart = JSON.parse(existingCart);

        //   // Agregar el nuevo ítem al carrito existente
        //   existingCart.items.push({
        //     variant_id: variantId,
        //     store: storeSelected,
        //     quantity: Number(quantityInput),
        //     // unique_id: Date.now().toString()
        //   });

        //   // Guardar el carrito actualizado en localStorage
        //   // localStorage.setItem('virtualCart', JSON.stringify(existingCart));
        // } else {
        //   // Si no existe un carrito, guardar el nuevo carrito en localStorage
        //   // localStorage.setItem('virtualCart', JSON.stringify(virtualCart));
        // }
        location.href = "/cart";        
      })
      .catch((error) => {
          console.error('Error:', error);
      });

    }

  } 

   /** Show Modal With Options - End */

  enablePickupButton(enable = false) {
    const pickupButton = document.getElementById('pickup-button');
    if (pickupButton) {
      pickupButton.disabled = !enable;
    }
  }

  setPickupButton(variantInfo = {}) { /** */

    const pickupOption = document.querySelector('.pickup-store__option[data-store-type="pick"] .pickup-store__option-type--available');
    const pickupButton = document.getElementById('pickup-button');

    // Si no existe un objeto para almacenar las funciones enlazadas, créalo
    if (!this.boundFunctions) {
      this.boundFunctions = {};
    }
  
    // Remueve los eventos anteriores si existen
    if (this.boundFunctions.pickupOption) {
      pickupOption.removeEventListener('click', this.boundFunctions.pickupOption);
    }
    if (this.boundFunctions.pickupButton) {
      pickupButton.removeEventListener('click', this.boundFunctions.pickupButton);
    }
  
    // Crea nuevas funciones enlazadas y guárdalas en el objeto
    this.boundFunctions.pickupOption = this.showModal.bind(this, variantInfo);
    this.boundFunctions.pickupButton = this.showModalWithOptions.bind(this, variantInfo);
  
    // Agrega los nuevos eventos
    pickupOption.addEventListener('click', this.boundFunctions.pickupOption);
    pickupButton.addEventListener('click', this.boundFunctions.pickupButton);

    this.translatePickUpSize(JSON.parse(localStorage.getItem('sizeChart')).size_chart, document.querySelector('.pickup-store-modal__product-variant-value[data-option-name="talla"]'));
  }

  // Sizes
  translatePickUpSize = (sizeChart, pickUpSize) => {      
      const sizeChartItem = sizeChart.find((item) => item.us.includes(pickUpSize.textContent.trim()) || pickUpSize.textContent.trim().includes(item.us));
      // const sizeChartItem = sizeChart.find((item) => item.current === pickUpSize.textContent.trim());      
      if (sizeChartItem !== undefined) {
        if (sizeChartItem && sizeChartItem.us.includes(pickUpSize.textContent.trim()) || pickUpSize.textContent.trim().includes(sizeChartItem.us)) {          
          pickUpSize.textContent = sizeChartItem.eu;
        }
      }
  }; 

  /**/

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    // console.log(`${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();    
  }


  

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input.input-talla')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* al cargar la pagina muestre el texto del color de la variante que corresponde
const fieldsets2 = Array.from(document.querySelectorAll('fieldset'));
const options2 = fieldsets2.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
});

//document.getElementById("valueColor").innerHTML = options2[0];*/



$("#RegisterForm-FirstName").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$("#RegisterForm-LastName").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$("#RegisterForm-email").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$("#RegisterForm-email").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$(".container-tyc-input input#tyc").change(function(e){
  if(e.target.checked){
  	$("#registerAccountBtn").prop("disabled", false)
    $("#menssage-tratamiento-register").css("display", "none");  
  }else{
  	$("#registerAccountBtn").prop("disabled", true)
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});



// Modificación de las Tallas:

// if($("#generoTallaje").val() == "NINOS") { 
//   changeNameTallas("K");
//   changeNameTallas("J");
// }

// // Input hidden Hombre:
// if($("#generoTallaje").val() == "HOMBRE"){
//   let countItemEstructura = 0;
  
//   $(".input-talla").each(function(i){    
//     if($(this).val().includes("M")){
//       countItemEstructura += 1;
//     }
//   })
//   if(countItemEstructura == 0){
//     $(".menu-mujer").attr("style", "display: none");
//     $(".menu-hombre").attr("style", "display: block");
//   }
//   changeNameTallas("H");
  
//   $(".menu-hombre").attr("style", "border-bottom: 0.15rem solid black;");
//   //let splitValueActive = options2[0].split("-");
//   //document.getElementById("valueTalla").innerHTML = splitValueActive[0].replace("H","");
// }else if($("#generoTallaje").val() == "MUJER"){

//   let countItemEstructura = 0;
//   $(".input-talla").each(function(i){
//     if($(this).val().charAt(0) == "H"){
//       countItemEstructura += 1;
//     }
//   })
  

//   if(countItemEstructura == 0){
//     $(".menu-hombre").attr("style", "display: none");
//     $(".menu-mujer").attr("style", "display: block");
//   }
//   changeNameTallas("M");
//   $(".menu-mujer").attr("style", "border-bottom: 0.15rem solid black;");
//   //let splitValueActive = options2[0].split("-");
//   //document.getElementById("valueTalla").innerHTML = splitValueActive[1].replace("M","");
// }else{ //Unisex
//   $(".input-talla").each(function(i){
//     if($(this).val().charAt(0) == "H"){
//       // Muestra el menú de Hombre y Mujer: 
//       $(".menu-mujer-unisex").attr("style", "display: block;");
//       $(".menu-hombre-unisex").attr("style", "display: block;  border-bottom: 0.15rem solid black;");

//       $(".input-talla").each(function(i){
        
//         let arrayValues;
//         if($(this).val().search("/") != -1){ //Si la tiene.
//           arrayValues = $(this).val().toUpperCase().split("/");
//         }else{
//           arrayValues = $(this).val().toUpperCase().split("-");
//         }

//         for (let index = 0; index < arrayValues.length; index++) {
//           let value = arrayValues[index];
//           if(value.charAt(0) == "H"){
//             $(this).attr("data-seleccionada", arrayValues[index]);
//             $(".item-talla").eq(i).text(arrayValues[index].replace("H", ""));
//           }
          
//         }
//       })
//       sortElementSelect('.content-tallas');
      
//     }else if($(this).val().charAt(0) == "M"){
//       $(".input-talla").each(function(i){

//         let arrayValues;
//         if($(this).val().search("/") != -1){ //Si la tiene.
//           arrayValues = $(this).val().toUpperCase().split("/");
//         }else{
//           arrayValues = $(this).val().toUpperCase().split("-");
//         }

//         for (let index = 0; index < arrayValues.length; index++) {
//           let value = arrayValues[index];
//           if(value.charAt(0) == "M"){
//             $(this).attr("data-seleccionada", arrayValues[index]);
//             $(".item-talla").eq(i).text(arrayValues[index].replace("M", ""));
//           }
//         }
//       })
//       sortElementSelect('.content-tallas');
//     }else{
//       $(this).attr("data-seleccionada", $(this).val());
//       changeNameTallas("");
//     }
//   })
// }

// $(".menu-hombre").click(function(){
//   changeNameTallas("H");
//   $(".menu-hombre").attr("style", "border-bottom: 0.15rem solid black;");
//   $(".menu-mujer").attr("style", "border-bottom: none;");
// })

// $(".menu-mujer").click(function(){
//   changeNameTallas("M");
//   $(".menu-mujer").attr("style", "border-bottom: 0.15rem solid black;");
//   $(".menu-hombre").attr("style", "border-bottom: none;");
// })

// $(".menu-hombre-unisex").click(function(){
//   changeNameTallas("H");
//   $(".input-talla").each(function(e, i){
//     if($(this).val().indexOf("H") == -1){
//       $(this).parent().attr("style", "display: none");
//     }else{
//       $(this).parent().attr("style", "display: block");       
     
//     }
//   })
//   $(".menu-hombre-unisex").attr("style", "display: block; border-bottom: 0.15rem solid black;");
//   $(".menu-mujer-unisex").attr("style", "display: block; border-bottom: none;");
// })

// $(".menu-mujer-unisex").click(function(){
//   changeNameTallas("M");
//   $(".input-talla").each(function(e, i){
//     if($(this).val().indexOf("M") == -1){
//       $(this).parent().attr("style", "display: none");
//     }else{
//       $(this).parent().attr("style", "display: block");
      
//     }
//   })
//   $(".menu-mujer-unisex").attr("style", "display: block; border-bottom: 0.15rem solid black;");
//   $(".menu-hombre-unisex").attr("style", "display: block; border-bottom: none;");
// })

// // Tallas del carrito:

// $(".value-variant-talla").each(function(i){

//   let arrayValues; 
//   // let arrayValues = $(this).attr("data-val-talla").trim().split("-");  
//   if($(this).attr("data-val-talla").search("/") != -1){ //Si la tiene.
//     arrayValues = $(this).attr("data-val-talla").trim().toUpperCase().split("/");     
//   }else{
//     arrayValues = $(this).attr("data-val-talla").trim().toUpperCase().split("-");  
//   }
  
//   for (let index = 0; index < arrayValues.length; index++) {
//     let value = arrayValues[index];     
//     if(value.charAt(0) == $(this).attr("data-genero")){
//       $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
//     }else if ($(this).attr("data-genero") == "unisex"){
//       if($(this).parent().parent().find(".value-properties-product").find("dd").text().charAt(0) == "H"){
//         $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
//       }else{
//         $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
//       }
//     }else{
//       $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
//     }
//   }
// })

// /*Cuando vienen sin el prefijo de sexo H o M*/
// $(".input-talla").click(function(){
//   if($(this).val().indexOf("M") == -1 && $(this).val().indexOf("H") == -1){
//     $(this).attr("data-seleccionada", $(this).val());  
//   }else{
//     if($(".menu-hombre-unisex").length > 0){
//       if($(".menu-hombre-unisex").attr("style").indexOf("border-bottom: 0.15rem solid black;") != -1){
//         $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
//       }else{
//         $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
//       }
//     }else{
//       $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
//     }
    
//     if($("#generoTallaje").val() == "MUJER"){
//       if($(".menu-hombre").length > 0 && $(".menu-hombre").attr("style") != undefined){
//         if($(".menu-hombre").attr("style").indexOf("border-bottom: 0.15rem solid black;") != -1){
//           $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
//         }else{
//           $(this).attr("data-seleccionada", $(this).val().split("-")[1]);  
//         }
//       }else if($(".menu-mujer").length > 0 && $(".menu-mujer").attr("style") != undefined){
//         if($(".menu-mujer").attr("style").indexOf("border-bottom: 0.15rem solid black;") != -1){
//           $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
//         }else{
//           $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
//         }
//       }
//     }
    
//     if($("#generoTallaje").val() == "HOMBRE"){
//       if($(".menu-hombre").length > 0 && $(".menu-hombre").attr("style") != undefined){
//         if($(".menu-hombre").attr("style").indexOf("border-bottom: 0.15rem solid black;") != -1){
//           $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
//         }else{
//           $(this).attr("data-seleccionada", $(this).val().split("-")[1]);  
//         }
//       }else if($(".menu-mujer").length > 0 && $(".menu-mujer").attr("style") != undefined){
//         if($(".menu-mujer").attr("style").indexOf("border-bottom: 0.15rem solid black;") != -1){
//           $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
//         }else{
//           $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
//         }
//       }
//     }
//   }
// });




// function changeNameTallas(type){
//   $(".input-talla").each(function(i){

//     let arrayValues;
//     if($(this).val().search("/") != -1){ //Si la tiene.
//       arrayValues = $(this).val().trim().toUpperCase().split("/");
//     }else{
//       arrayValues = $(this).val().trim().toUpperCase().split("-");
//     }
//     for (let index = 0; index < arrayValues.length; index++) {
//       let value = arrayValues[index];
//       if(value.charAt(0) == type){
//         $(this).attr("data-seleccionada", arrayValues[index]);
//         $(".item-talla").eq(i).text(arrayValues[index].replace(type, ""));
//       }
//     }
//     // $(this).attr("data-seleccionada", "");
//   });

//   sortElementSelect('.content-tallas');
// }

// function sortElementSelect(idList){
// 	var $myList = $(idList);
  	
//     var $item = $myList.children('.container-item-talla');

//     var sortList = Array.prototype.sort.bind($item);
  
  	
//     sortList(function ( a, b ) {		
//         // Cache inner content from the first element (a) and the next sibling (b)
//         var aText = a.children[1].innerText;
//         var bText = b.children[1].innerText;

//         // Returning -1 will place element `a` before element `b`
//         if ( aText < bText ) {
//             return -1;
//         }

//         // Returning 1 will do the opposite
//         if ( aText > bText ) {
//             return 1;
//         }

//         // Returning 0 leaves them as-is
//         return 0;
//     });
      
//     $myList.append($item);
// }

// /** Fin de Tallas **/ 


(() => {
  let all_container_item_talla = document.querySelectorAll('.content-tallas .container-item-talla ');
  for (let i=0; i<all_container_item_talla.length; i++){
    if(all_container_item_talla[i].dataset.sku === ''){
      all_container_item_talla[i].classList.add('no-size-inventory');
      all_container_item_talla[i].querySelector('.input-talla').setAttribute("disabled", "");
      all_container_item_talla[i].onclick = null;
    }
  }
})();


/** Card Collection Media **/
(()=>{


  var render_control = false;

  window.addEventListener('globoFilterRenderCompleted', function () {
    const globo_filter_load = document.getElementById('gf-grid');
    let globo_products = document.querySelector('#gf-products');
    let collection_url = window.location.href;
    // let collection_names = ['crush-para-mujer', 'back-to-school', 'crocs-para-hombre', 'crocs-para-mujer', 'crocs-para-ninos'];
    let collection_names = ['jibbitz%E2%84%A2'];

    let collection_obj = {
      name: 'crush-para-mujer',
      img_url: 'prueba.com'
    }
    
    for (let i = 0; i < collection_names.length; i++) {
      let collection_name = new RegExp(collection_names[i]);      
      if(collection_name.test(collection_url)){
        if(globo_products && render_control === false){
          //  globo_products.insertAdjacentHTML('afterbegin', 
          //     `<div class="collection-banner-card spf-col-xl-3 spf-col-lg-4 spf-col-md-6 spf-col-sm-6 spf-col-6" id="spf-product-custom-card-id">
          //         <div class="spf-product-card spf-product-card__center spf-product-custom-card__img">
          //           <div class="spf-product-card__inner">
          //             <div class="spf-product-custom-card">
          //               <div class="spf-product-custom-card__inner">
                        
          //               <!--div class="spf-product-custom-card__img"></div-->
      
          //               <div class="pf-product-custom-card__video">
          //                 <!--video class="pf-product-custom-card__video-src" src="https://cdn.shopify.com/videos/c/o/v/603d80fe6c1e46d8bbca7f9273d7c16a.mp4" autoplay="" loop="" preload="auto" muted=""></video-->
          //                 <video class="pf-product-custom-card__video-src" src="https://cdn.shopify.com/videos/c/o/v/d2a972bd77f24ca08c58823f42705174.mp4" autoplay="" loop="" preload="auto" muted=""></video>                    
          //               </div>
                        
          //               </div>
          //             </div>
          //           </div>
                    
          //         </div>
          //       </div>`
          //     );
          
          //     globo_products.insertBefore(document.getElementById('spf-product-custom-card-id'), globo_products.children[6]);
          
         render_control = true;

        // globo_products.insertBefore(document.getElementById('spf-product-custom-card-id'), globo_products.children[11]);

        // const spf_product_card_height = document.querySelector('#gf-products .collection-banner-card').getBoundingClientRect().height;
        // console.log(`Altura de la carta: ${spf_product_card_height}`);

        // const spf_product_custom_card_id = document.getElementById('spf-product-custom-card-id');
        // spf_product_custom_card_id.style.height = spf_product_card_height;
        }
        
      }      
    }
    
  var custom_element = document.getElementById('spf-product-custom-card-id'); // → Carta

    if(custom_element){
        var propiedades_del_elemento = custom_element.getBoundingClientRect(); // → Propiedades del elemento
    
  let contenedor_del_video = document.querySelector('.pf-product-custom-card__video'); // → Contenedor del vídeo
  let video_elemento = document.querySelector('.pf-product-custom-card__video-src'); // → Video
    
  contenedor_del_video.style.height = `${propiedades_del_elemento.height}px`;

  video_elemento.style.height = `${propiedades_del_elemento.height}px`

    
  // video_elemento.style.width = `calc(${propiedades_del_elemento.width}px * 2)`; 

    }
   


    

     window.addEventListener('resize', function() {  

      let contenedor_del_video = document.querySelector('.pf-product-custom-card__video'); // → Contenedor del vídeo
      let custom_element = document.getElementById('spf-product-custom-card-id'); // → Carta
      let video_elemento = document.querySelector('.pf-product-custom-card__video-src'); // → Video
      if(custom_element) {
  
      propiedades_del_elemento = custom_element.getBoundingClientRect(); // → Propiedades del elemento
      
      contenedor_del_video.style.width = `${propiedades_del_elemento.width}px`;
      contenedor_del_video.style.height = `${propiedades_del_elemento.height}px`;
      video_elemento.style.height = `${propiedades_del_elemento.height}px`
        
      // contenedor_del_video.style.height = `${propiedades_del_elemento.height}px`;  
      // video_elemento.style.width = `calc(${propiedades_del_elemento.width}px * 2)`; 
        
        
      // console.log(`Ancho Elemento: ${propiedades_del_elemento}`);
      // console.log(`AltoElemento: ${propiedades_del_elemento.height}`);
      }
    });

    
});
})();


// Hiperenlace en el pie de pagina 
let menu_item_blank = document.querySelector("#shopify-section-footer > footer > div.footer__content-top.page-width.restriction-content > div.footer__blocks-wrapper.grid.grid--1-col.grid--2-col.grid--4-col-tablet > div:nth-child(4) > ul > li:nth-child(1) > a");
menu_item_blank.setAttribute('target', '_blank');


  /* Cambiar texto de los Metacampos a Customer Hub App */ 
  window.addEventListener('load', () => {
    if(location.pathname ==='/account'){
      let customer_info = document.querySelector("#chShowAddress-Block > div:nth-child(2) > div.chContent-BPCBI-Content > div.chContent-BPCBI-Content-Address > div.chcf_load_el").childNodes;
      customer_info.forEach((e) => {  
        switch (e.querySelector('.chcf_el_label').textContent) {
          case 'birthday':
            e.querySelector('.chcf_el_label').textContent = 'Cumpleaños';
            break;
          case 'gender':
            e.querySelector('.chcf_el_label').textContent = 'Género';
            break;
          case 'city':
            e.querySelector('.chcf_el_label').textContent = 'Ciudad';
          break;
          case 'department':
            e.querySelector('.chcf_el_label').textContent = 'Departamento';
          break;
        }
      });  

     

    }  

    if(location.pathname ==='/account/addresses'){
      chMfHolder_birthday.firstChild.textContent = 'Cumpleaños';
      chMfHolder_gender.firstChild.textContent = 'Género';
      chMfHolder_city.firstChild.textContent = 'Ciudad';
      chMfHolder_department.firstChild.textContent = 'Departamento';

      chMfHolder_gender.querySelector('textarea').addEventListener('keyup', (e) => {
        e.target.value = e.target.value.toUpperCase()
        
        // if(!e.target.value.includes('MASCULINO') || !e.target.value.includes('FEMENINO')){
        //   e.target.value = 'MASCULINO';
        // }
      });
    }

    if(location.href === 'https://crocs.com.co/account/addresses?a=profile'){
      // console.log(location.href);
      // chMfHolder_gender.style.display = 'none';
      let gender_customer_options = ['MASCULINO', 'FEMENINO'];
      let department_customer, city_customer;

      department_customer = chMfHolder_department.querySelector('textarea').value;
      department_city = chMfHolder_city.querySelector('textarea').value;

      // console.log(`DEPARTAMENTO: ${department_customer} CIUDAD: ${department_city}` );


      // Colombia Array 
      let colombia = [  
        {  
            "id":0,
            "departamento":"Amazonas",
            "ciudades":[  
                "Leticia",
                "Puerto Nari\u00f1o"
            ]
        },
        {  
            "id":1,
            "departamento":"Antioquia",
            "ciudades":[  
                "Abejorral",
                "Abriaqu\u00ed",
                "Alejandr\u00eda",
                "Amag\u00e1",
                "Amalfi",
                "Andes",
                "Angel\u00f3polis",
                "Angostura",
                "Anor\u00ed",
                "Anz\u00e1",
                "Apartad\u00f3",
                "Arboletes",
                "Argelia",
                "Armenia",
                "Barbosa",
                "Bello",
                "Belmira",
                "Betania",
                "Betulia",
                "Brice\u00f1o",
                "Buritic\u00e1",
                "C\u00e1ceres",
                "Caicedo",
                "Caldas",
                "Campamento",
                "Ca\u00f1asgordas",
                "Caracol\u00ed",
                "Caramanta",
                "Carepa",
                "Carolina del Pr\u00edncipe",
                "Caucasia",
                "Chigorod\u00f3",
                "Cisneros",
                "Ciudad Bol\u00edvar",
                "Cocorn\u00e1",
                "Concepci\u00f3n",
                "Concordia",
                "Copacabana",
                "Dabeiba",
                "Donmat\u00edas",
                "Eb\u00e9jico",
                "El Bagre",
                "El Carmen de Viboral",
                "El Pe\u00f1ol",
                "El Retiro",
                "El Santuario",
                "Entrerr\u00edos",
                "Envigado",
                "Fredonia",
                "Frontino",
                "Giraldo",
                "Girardota",
                "G\u00f3mez Plata",
                "Granada",
                "Guadalupe",
                "Guarne",
                "Guatap\u00e9",
                "Heliconia",
                "Hispania",
                "Itag\u00fc\u00ed",
                "Ituango",
                "Jard\u00edn",
                "Jeric\u00f3",
                "La Ceja",
                "La Estrella",
                "La Pintada",
                "La Uni\u00f3n",
                "Liborina",
                "Maceo",
                "Marinilla",
                "Medell\u00edn",
                "Montebello",
                "Murind\u00f3",
                "Mutat\u00e1",
                "Nari\u00f1o",
                "Nech\u00ed",
                "Necocl\u00ed",
                "Olaya",
                "Peque",
                "Pueblorrico",
                "Puerto Berr\u00edo",
                "Puerto Nare",
                "Puerto Triunfo",
                "Remedios",
                "Rionegro",
                "Sabanalarga",
                "Sabaneta",
                "Salgar",
                "San Andr\u00e9s de Cuerquia",
                "San Carlos",
                "San Francisco",
                "San Jer\u00f3nimo",
                "San Jos\u00e9 de la Monta\u00f1a",
                "San Juan de Urab\u00e1",
                "San Luis",
                "San Pedro de Urab\u00e1",
                "San Pedro de los Milagros",
                "San Rafael",
                "San Roque",
                "San Vicente",
                "Santa B\u00e1rbara",
                "Santa Fe de Antioquia",
                "Santa Rosa de Osos",
                "Santo Domingo",
                "Segovia",
                "Sons\u00f3n",
                "Sopetr\u00e1n",
                "T\u00e1mesis",
                "Taraz\u00e1",
                "Tarso",
                "Titirib\u00ed",
                "Toledo",
                "Turbo",
                "Uramita",
                "Urrao",
                "Valdivia",
                "Valpara\u00edso",
                "Vegach\u00ed",
                "Venecia",
                "Vig\u00eda del Fuerte",
                "Yal\u00ed",
                "Yarumal",
                "Yolomb\u00f3",
                "Yond\u00f3",
                "Zaragoza"
            ]
        },
        {  
            "id":2,
            "departamento":"Arauca",
            "ciudades":[  
                "Arauca",
                "Arauquita",
                "Cravo Norte",
                "Fortul",
                "Puerto Rond\u00f3n",
                "Saravena",
                "Tame"
            ]
        },
        {  
            "id":3,
            "departamento":"Atl\u00e1ntico",
            "ciudades":[  
                "Baranoa",
                "Barranquilla",
                "Campo de la Cruz",
                "Candelaria",
                "Galapa",
                "Juan de Acosta",
                "Luruaco",
                "Malambo",
                "Manat\u00ed",
                "Palmar de Varela",
                "Pioj\u00f3",
                "Polonuevo",
                "Ponedera",
                "Puerto Colombia",
                "Repel\u00f3n",
                "Sabanagrande",
                "Sabanalarga",
                "Santa Luc\u00eda",
                "Santo Tom\u00e1s",
                "Soledad",
                "Su\u00e1n",
                "Tubar\u00e1",
                "Usiacur\u00ed"
            ]
        },
        {  
            "id":4,
            "departamento":"Bol\u00edvar",
            "ciudades":[  
                "Ach\u00ed",
                "Altos del Rosario",
                "Arenal",
                "Arjona",
                "Arroyohondo",
                "Barranco de Loba",
                "Brazuelo de Papayal",
                "Calamar",
                "Cantagallo",
                "Cartagena de Indias",
                "Cicuco",
                "Clemencia",
                "C\u00f3rdoba",
                "El Carmen de Bol\u00edvar",
                "El Guamo",
                "El Pe\u00f1\u00f3n",
                "Hatillo de Loba",
                "Magangu\u00e9",
                "Mahates",
                "Margarita",
                "Mar\u00eda la Baja",
                "Momp\u00f3s",
                "Montecristo",
                "Morales",
                "Noros\u00ed",
                "Pinillos",
                "Regidor",
                "R\u00edo Viejo",
                "San Crist\u00f3bal",
                "San Estanislao",
                "San Fernando",
                "San Jacinto del Cauca",
                "San Jacinto",
                "San Juan Nepomuceno",
                "San Mart\u00edn de Loba",
                "San Pablo",
                "Santa Catalina",
                "Santa Rosa",
                "Santa Rosa del Sur",
                "Simit\u00ed",
                "Soplaviento",
                "Talaigua Nuevo",
                "Tiquisio",
                "Turbaco",
                "Turban\u00e1",
                "Villanueva",
                "Zambrano"
            ]
        },
        {  
            "id":5,
            "departamento":"Boyac\u00e1",
            "ciudades":[  
                "Almeida",
                "Aquitania",
                "Arcabuco",
                "Bel\u00e9n",
                "Berbeo",
                "Bet\u00e9itiva",
                "Boavita",
                "Boyac\u00e1",
                "Brice\u00f1o",
                "Buenavista",
                "Busbanz\u00e1",
                "Caldas",
                "Campohermoso",
                "Cerinza",
                "Chinavita",
                "Chiquinquir\u00e1",
                "Ch\u00edquiza",
                "Chiscas",
                "Chita",
                "Chitaraque",
                "Chivat\u00e1",
                "Chivor",
                "Ci\u00e9nega",
                "C\u00f3mbita",
                "Coper",
                "Corrales",
                "Covarach\u00eda",
                "Cubar\u00e1",
                "Cucaita",
                "Cu\u00edtiva",
                "Duitama",
                "El Cocuy",
                "El Espino",
                "Firavitoba",
                "Floresta",
                "Gachantiv\u00e1",
                "G\u00e1meza",
                "Garagoa",
                "Guacamayas",
                "Guateque",
                "Guayat\u00e1",
                "G\u00fcic\u00e1n",
                "Iza",
                "Jenesano",
                "Jeric\u00f3",
                "La Capilla",
                "La Uvita",
                "La Victoria",
                "Labranzagrande",
                "Macanal",
                "Marip\u00ed",
                "Miraflores",
                "Mongua",
                "Mongu\u00ed",
                "Moniquir\u00e1",
                "Motavita",
                "Muzo",
                "Nobsa",
                "Nuevo Col\u00f3n",
                "Oicat\u00e1",
                "Otanche",
                "Pachavita",
                "P\u00e1ez",
                "Paipa",
                "Pajarito",
                "Panqueba",
                "Pauna",
                "Paya",
                "Paz del R\u00edo",
                "Pesca",
                "Pisba",
                "Puerto Boyac\u00e1",
                "Qu\u00edpama",
                "Ramiriqu\u00ed",
                "R\u00e1quira",
                "Rond\u00f3n",
                "Saboy\u00e1",
                "S\u00e1chica",
                "Samac\u00e1",
                "San Eduardo",
                "San Jos\u00e9 de Pare",
                "San Luis de Gaceno",
                "San Mateo",
                "San Miguel de Sema",
                "San Pablo de Borbur",
                "Santa Mar\u00eda",
                "Santa Rosa de Viterbo",
                "Santa Sof\u00eda",
                "Santana",
                "Sativanorte",
                "Sativasur",
                "Siachoque",
                "Soat\u00e1",
                "Socha",
                "Socot\u00e1",
                "Sogamoso",
                "Somondoco",
                "Sora",
                "Sorac\u00e1",
                "Sotaquir\u00e1",
                "Susac\u00f3n",
                "Sutamarch\u00e1n",
                "Sutatenza",
                "Tasco",
                "Tenza",
                "Tiban\u00e1",
                "Tibasosa",
                "Tinjac\u00e1",
                "Tipacoque",
                "Toca",
                "Tog\u00fc\u00ed",
                "T\u00f3paga",
                "Tota",
                "Tunja",
                "Tunungu\u00e1",
                "Turmequ\u00e9",
                "Tuta",
                "Tutaz\u00e1",
                "\u00dambita",
                "Ventaquemada",
                "Villa de Leyva",
                "Viracach\u00e1",
                "Zetaquira"
            ]
        },
        {  
            "id":6,
            "departamento":"Caldas",
            "ciudades":[  
                "Aguadas",
                "Anserma",
                "Aranzazu",
                "Belalc\u00e1zar",
                "Chinchin\u00e1",
                "Filadelfia",
                "La Dorada",
                "La Merced",
                "Manizales",
                "Manzanares",
                "Marmato",
                "Marquetalia",
                "Marulanda",
                "Neira",
                "Norcasia",
                "P\u00e1cora",
                "Palestina",
                "Pensilvania",
                "Riosucio",
                "Risaralda",
                "Salamina",
                "Saman\u00e1",
                "San Jos\u00e9",
                "Sup\u00eda",
                "Victoria",
                "Villamar\u00eda",
                "Viterbo"
            ]
        },
        {  
            "id":7,
            "departamento":"Caquet\u00e1",
            "ciudades":[  
                "Albania",
                "Bel\u00e9n de los Andaqu\u00edes",
                "Cartagena del Chair\u00e1",
                "Curillo",
                "El Doncello",
                "El Paujil",
                "Florencia",
                "La Monta\u00f1ita",
                "Mil\u00e1n",
                "Morelia",
                "Puerto Rico",
                "San Jos\u00e9 del Fragua",
                "San Vicente del Cagu\u00e1n",
                "Solano",
                "Solita",
                "Valpara\u00edso"
            ]
        },
        {  
            "id":8,
            "departamento":"Casanare",
            "ciudades":[  
                "Aguazul",
                "Ch\u00e1meza",
                "Hato Corozal",
                "La Salina",
                "Man\u00ed",
                "Monterrey",
                "Nunch\u00eda",
                "Orocu\u00e9",
                "Paz de Ariporo",
                "Pore",
                "Recetor",
                "Sabanalarga",
                "S\u00e1cama",
                "San Luis de Palenque",
                "T\u00e1mara",
                "Tauramena",
                "Trinidad",
                "Villanueva",
                "Yopal"
            ]
        },
        {  
            "id":9,
            "departamento":"Cauca",
            "ciudades":[  
                "Almaguer",
                "Argelia",
                "Balboa",
                "Bol\u00edvar",
                "Buenos Aires",
                "Cajib\u00edo",
                "Caldono",
                "Caloto",
                "Corinto",
                "El Tambo",
                "Florencia",
                "Guachen\u00e9",
                "Guap\u00ed",
                "Inz\u00e1",
                "Jambal\u00f3",
                "La Sierra",
                "La Vega",
                "L\u00f3pez de Micay",
                "Mercaderes",
                "Miranda",
                "Morales",
                "Padilla",
                "P\u00e1ez",
                "Pat\u00eda",
                "Piamonte",
                "Piendam\u00f3",
                "Popay\u00e1n",
                "Puerto Tejada",
                "Purac\u00e9",
                "Rosas",
                "San Sebasti\u00e1n",
                "Santa Rosa",
                "Santander de Quilichao",
                "Silvia",
                "Sotar\u00e1",
                "Su\u00e1rez",
                "Sucre",
                "Timb\u00edo",
                "Timbiqu\u00ed",
                "Torib\u00edo",
                "Totor\u00f3",
                "Villa Rica"
            ]
        },
        {  
            "id":10,
            "departamento":"Cesar",
            "ciudades":[  
                "Aguachica",
                "Agust\u00edn Codazzi",
                "Astrea",
                "Becerril",
                "Bosconia",
                "Chimichagua",
                "Chiriguan\u00e1",
                "Curuman\u00ed",
                "El Copey",
                "El Paso",
                "Gamarra",
                "Gonz\u00e1lez",
                "La Gloria (Cesar)",
                "La Jagua de Ibirico",
                "La Paz",
                "Manaure Balc\u00f3n del Cesar",
                "Pailitas",
                "Pelaya",
                "Pueblo Bello",
                "R\u00edo de Oro",
                "San Alberto",
                "San Diego",
                "San Mart\u00edn",
                "Tamalameque",
                "Valledupar"
            ]
        },
        {  
            "id":11,
            "departamento":"Choc\u00f3",
            "ciudades":[  
                "Acand\u00ed",
                "Alto Baud\u00f3",
                "Bagad\u00f3",
                "Bah\u00eda Solano",
                "Bajo Baud\u00f3",
                "Bojay\u00e1",
                "Cant\u00f3n de San Pablo",
                "C\u00e9rtegui",
                "Condoto",
                "El Atrato",
                "El Carmen de Atrato",
                "El Carmen del Dari\u00e9n",
                "Istmina",
                "Jurad\u00f3",
                "Litoral de San Juan",
                "Llor\u00f3",
                "Medio Atrato",
                "Medio Baud\u00f3",
                "Medio San Juan",
                "N\u00f3vita",
                "Nuqu\u00ed",
                "Quibd\u00f3",
                "R\u00edo Ir\u00f3",
                "R\u00edo Quito",
                "Riosucio",
                "San Jos\u00e9 del Palmar",
                "Sip\u00ed",
                "Tad\u00f3",
                "Uni\u00f3n Panamericana",
                "Ungu\u00eda"
            ]
        },
        {  
            "id":12,
            "departamento":"Cundinamarca",
            "ciudades":[  
                "Agua de Dios",
                "Alb\u00e1n",
                "Anapoima",
                "Anolaima",
                "Apulo",
                "Arbel\u00e1ez",
                "Beltr\u00e1n",
                "Bituima",
                "Bogot\u00e1",
                "Bojac\u00e1",
                "Cabrera",
                "Cachipay",
                "Cajic\u00e1",
                "Caparrap\u00ed",
                "C\u00e1queza",
                "Carmen de Carupa",
                "Chaguan\u00ed",
                "Ch\u00eda",
                "Chipaque",
                "Choach\u00ed",
                "Chocont\u00e1",
                "Cogua",
                "Cota",
                "Cucunub\u00e1",
                "El Colegio",
                "El Pe\u00f1\u00f3n",
                "El Rosal",
                "Facatativ\u00e1",
                "F\u00f3meque",
                "Fosca",
                "Funza",
                "F\u00faquene",
                "Fusagasug\u00e1",
                "Gachal\u00e1",
                "Gachancip\u00e1",
                "Gachet\u00e1",
                "Gama",
                "Girardot",
                "Granada",
                "Guachet\u00e1",
                "Guaduas",
                "Guasca",
                "Guataqu\u00ed",
                "Guatavita",
                "Guayabal de S\u00edquima",
                "Guayabetal",
                "Guti\u00e9rrez",
                "Jerusal\u00e9n",
                "Jun\u00edn",
                "La Calera",
                "La Mesa",
                "La Palma",
                "La Pe\u00f1a",
                "La Vega",
                "Lenguazaque",
                "Machet\u00e1",
                "Madrid",
                "Manta",
                "Medina",
                "Mosquera",
                "Nari\u00f1o",
                "Nemoc\u00f3n",
                "Nilo",
                "Nimaima",
                "Nocaima",
                "Pacho",
                "Paime",
                "Pandi",
                "Paratebueno",
                "Pasca",
                "Puerto Salgar",
                "Pul\u00ed",
                "Quebradanegra",
                "Quetame",
                "Quipile",
                "Ricaurte",
                "San Antonio del Tequendama",
                "San Bernardo",
                "San Cayetano",
                "San Francisco",
                "San Juan de Rioseco",
                "Sasaima",
                "Sesquil\u00e9",
                "Sibat\u00e9",
                "Silvania",
                "Simijaca",
                "Soacha",
                "Sop\u00f3",
                "Subachoque",
                "Suesca",
                "Supat\u00e1",
                "Susa",
                "Sutatausa",
                "Tabio",
                "Tausa",
                "Tena",
                "Tenjo",
                "Tibacuy",
                "Tibirita",
                "Tocaima",
                "Tocancip\u00e1",
                "Topaip\u00ed",
                "Ubal\u00e1",
                "Ubaque",
                "Ubat\u00e9",
                "Une",
                "\u00datica",
                "Venecia",
                "Vergara",
                "Vian\u00ed",
                "Villag\u00f3mez",
                "Villapinz\u00f3n",
                "Villeta",
                "Viot\u00e1",
                "Yacop\u00ed",
                "Zipac\u00f3n",
                "Zipaquir\u00e1"
            ]
        },
        {  
            "id":13,
            "departamento":"C\u00f3rdoba",
            "ciudades":[  
                "Ayapel",
                "Buenavista",
                "Canalete",
                "Ceret\u00e9",
                "Chim\u00e1",
                "Chin\u00fa",
                "Ci\u00e9naga de Oro",
                "Cotorra",
                "La Apartada",
                "Lorica",
                "Los C\u00f3rdobas",
                "Momil",
                "Montel\u00edbano",
                "Monter\u00eda",
                "Mo\u00f1itos",
                "Planeta Rica",
                "Pueblo Nuevo",
                "Puerto Escondido",
                "Puerto Libertador",
                "Pur\u00edsima",
                "Sahag\u00fan",
                "San Andr\u00e9s de Sotavento",
                "San Antero",
                "San Bernardo del Viento",
                "San Carlos",
                "San Jos\u00e9 de Ur\u00e9",
                "San Pelayo",
                "Tierralta",
                "Tuch\u00edn",
                "Valencia"
            ]
        },
        {  
            "id":14,
            "departamento":"Guain\u00eda",
            "ciudades":[  
                "In\u00edrida"
            ]
        },
        {  
            "id":15,
            "departamento":"Guaviare",
            "ciudades":[  
                "Calamar",
                "El Retorno",
                "Miraflores",
                "San Jos\u00e9 del Guaviare"
            ]
        },
        {  
            "id":16,
            "departamento":"Huila",
            "ciudades":[  
                "Acevedo",
                "Agrado",
                "Aipe",
                "Algeciras",
                "Altamira",
                "Baraya",
                "Campoalegre",
                "Colombia",
                "El Pital",
                "El\u00edas",
                "Garz\u00f3n",
                "Gigante",
                "Guadalupe",
                "Hobo",
                "\u00cdquira",
                "Isnos",
                "La Argentina",
                "La Plata",
                "N\u00e1taga",
                "Neiva",
                "Oporapa",
                "Paicol",
                "Palermo",
                "Palestina",
                "Pitalito",
                "Rivera",
                "Saladoblanco",
                "San Agust\u00edn",
                "Santa Mar\u00eda",
                "Suaza",
                "Tarqui",
                "Tello",
                "Teruel",
                "Tesalia",
                "Timan\u00e1",
                "Villavieja",
                "Yaguar\u00e1"
            ]
        },
        {  
            "id":17,
            "departamento":"La Guajira",
            "ciudades":[  
                "Albania",
                "Barrancas",
                "Dibulla",
                "Distracci\u00f3n",
                "El Molino",
                "Fonseca",
                "Hatonuevo",
                "La Jagua del Pilar",
                "Maicao",
                "Manaure",
                "Riohacha",
                "San Juan del Cesar",
                "Uribia",
                "Urumita",
                "Villanueva"
            ]
        },
        {  
            "id":18,
            "departamento":"Magdalena",
            "ciudades":[  
                "Algarrobo",
                "Aracataca",
                "Ariguan\u00ed",
                "Cerro de San Antonio",
                "Chibolo",
                "Chibolo",
                "Ci\u00e9naga",
                "Concordia",
                "El Banco",
                "El Pi\u00f1\u00f3n",
                "El Ret\u00e9n",
                "Fundaci\u00f3n",
                "Guamal",
                "Nueva Granada",
                "Pedraza",
                "Piji\u00f1o del Carmen",
                "Pivijay",
                "Plato",
                "Pueblo Viejo",
                "Remolino",
                "Sabanas de San \u00c1ngel",
                "Salamina",
                "San Sebasti\u00e1n de Buenavista",
                "San Zen\u00f3n",
                "Santa Ana",
                "Santa B\u00e1rbara de Pinto",
                "Santa Marta",
                "Sitionuevo",
                "Tenerife",
                "Zapay\u00e1n",
                "Zona Bananera"
            ]
        },
        {  
            "id":19,
            "departamento":"Meta",
            "ciudades":[  
                "Acac\u00edas",
                "Barranca de Up\u00eda",
                "Cabuyaro",
                "Castilla la Nueva",
                "Cubarral",
                "Cumaral",
                "El Calvario",
                "El Castillo",
                "El Dorado",
                "Fuente de Oro",
                "Granada",
                "Guamal",
                "La Macarena",
                "La Uribe",
                "Lejan\u00edas",
                "Mapirip\u00e1n",
                "Mesetas",
                "Puerto Concordia",
                "Puerto Gait\u00e1n",
                "Puerto Lleras",
                "Puerto L\u00f3pez",
                "Puerto Rico",
                "Restrepo",
                "San Carlos de Guaroa",
                "San Juan de Arama",
                "San Juanito",
                "San Mart\u00edn",
                "Villavicencio",
                "Vista Hermosa"
            ]
        },
        {  
            "id":20,
            "departamento":"Nari\u00f1o",
            "ciudades":[  
                "Aldana",
                "Ancuy\u00e1",
                "Arboleda",
                "Barbacoas",
                "Bel\u00e9n",
                "Buesaco",
                "Chachag\u00fc\u00ed",
                "Col\u00f3n",
                "Consac\u00e1",
                "Contadero",
                "C\u00f3rdoba",
                "Cuaspud",
                "Cumbal",
                "Cumbitara",
                "El Charco",
                "El Pe\u00f1ol",
                "El Rosario",
                "El Tabl\u00f3n",
                "El Tambo",
                "Francisco Pizarro",
                "Funes",
                "Guachucal",
                "Guaitarilla",
                "Gualmat\u00e1n",
                "Iles",
                "Imu\u00e9s",
                "Ipiales",
                "La Cruz",
                "La Florida",
                "La Llanada",
                "La Tola",
                "La Uni\u00f3n",
                "Leiva",
                "Linares",
                "Los Andes",
                "Mag\u00fc\u00ed Pay\u00e1n",
                "Mallama",
                "Mosquera",
                "Nari\u00f1o",
                "Olaya Herrera",
                "Ospina",
                "Pasto",
                "Policarpa",
                "Potos\u00ed",
                "Providencia",
                "Puerres",
                "Pupiales",
                "Ricaurte",
                "Roberto Pay\u00e1n",
                "Samaniego",
                "San Bernardo",
                "San Jos\u00e9 de Alb\u00e1n",
                "San Lorenzo",
                "San Pablo",
                "San Pedro de Cartago",
                "Sandon\u00e1",
                "Santa B\u00e1rbara",
                "Santacruz",
                "Sapuyes",
                "Taminango",
                "Tangua",
                "Tumaco",
                "T\u00faquerres",
                "Yacuanquer"
            ]
        },
        {  
            "id":21,
            "departamento":"Norte de Santander",
            "ciudades":[  
                "\u00c1brego",
                "Arboledas",
                "Bochalema",
                "Bucarasica",
                "C\u00e1chira",
                "C\u00e1cota",
                "Chin\u00e1cota",
                "Chitag\u00e1",
                "Convenci\u00f3n",
                "C\u00facuta",
                "Cucutilla",
                "Duran\u00eda",
                "El Carmen",
                "El Tarra",
                "El Zulia",
                "Gramalote",
                "Hacar\u00ed",
                "Herr\u00e1n",
                "La Esperanza",
                "La Playa de Bel\u00e9n",
                "Labateca",
                "Los Patios",
                "Lourdes",
                "Mutiscua",
                "Oca\u00f1a",
                "Pamplona",
                "Pamplonita",
                "Puerto Santander",
                "Ragonvalia",
                "Salazar de Las Palmas",
                "San Calixto",
                "San Cayetano",
                "Santiago",
                "Santo Domingo de Silos",
                "Sardinata",
                "Teorama",
                "Tib\u00fa",
                "Toledo",
                "Villa Caro",
                "Villa del Rosario"
            ]
        },
        {  
            "id":22,
            "departamento":"Putumayo",
            "ciudades":[  
                "Col\u00f3n",
                "Mocoa",
                "Orito",
                "Puerto As\u00eds",
                "Puerto Caicedo",
                "Puerto Guzm\u00e1n",
                "Puerto Legu\u00edzamo",
                "San Francisco",
                "San Miguel",
                "Santiago",
                "Sibundoy",
                "Valle del Guamuez",
                "Villagarz\u00f3n"
            ]
        },
        {  
            "id":23,
            "departamento":"Quind\u00edo",
            "ciudades":[  
                "Armenia",
                "Buenavista",
                "Calarc\u00e1",
                "Circasia",
                "C\u00f3rdoba",
                "Filandia",
                "G\u00e9nova",
                "La Tebaida",
                "Montenegro",
                "Pijao",
                "Quimbaya",
                "Salento"
            ]
        },
        {  
            "id":24,
            "departamento":"Risaralda",
            "ciudades":[  
                "Ap\u00eda",
                "Balboa",
                "Bel\u00e9n de Umbr\u00eda",
                "Dosquebradas",
                "Gu\u00e1tica",
                "La Celia",
                "La Virginia",
                "Marsella",
                "Mistrat\u00f3",
                "Pereira",
                "Pueblo Rico",
                "Quinch\u00eda",
                "Santa Rosa de Cabal",
                "Santuario"
            ]
        },
        {  
            "id":25,
            "departamento":"San Andr\u00e9s y Providencia",
            "ciudades":[  
                "Providencia y Santa Catalina Islas",
                "San Andr\u00e9s"
            ]
        },
        {  
            "id":26,
            "departamento":"Santander",
            "ciudades":[  
                "Aguada",
                "Albania",
                "Aratoca",
                "Barbosa",
                "Barichara",
                "Barrancabermeja",
                "Betulia",
                "Bol\u00edvar",
                "Bucaramanga",
                "Cabrera",
                "California",
                "Capitanejo",
                "Carcas\u00ed",
                "Cepit\u00e1",
                "Cerrito",
                "Charal\u00e1",
                "Charta",
                "Chima",
                "Chipat\u00e1",
                "Cimitarra",
                "Concepci\u00f3n",
                "Confines",
                "Contrataci\u00f3n",
                "Coromoro",
                "Curit\u00ed",
                "El Carmen de Chucur\u00ed",
                "El Guacamayo",
                "El Pe\u00f1\u00f3n",
                "El Play\u00f3n",
                "El Socorro",
                "Encino",
                "Enciso",
                "Flori\u00e1n",
                "Floridablanca",
                "Gal\u00e1n",
                "G\u00e1mbita",
                "Gir\u00f3n",
                "Guaca",
                "Guadalupe",
                "Guapot\u00e1",
                "Guavat\u00e1",
                "G\u00fcepsa",
                "Hato",
                "Jes\u00fas Mar\u00eda",
                "Jord\u00e1n",
                "La Belleza",
                "La Paz",
                "Land\u00e1zuri",
                "Lebrija",
                "Los Santos",
                "Macaravita",
                "M\u00e1laga",
                "Matanza",
                "Mogotes",
                "Molagavita",
                "Ocamonte",
                "Oiba",
                "Onzaga",
                "Palmar",
                "Palmas del Socorro",
                "P\u00e1ramo",
                "Piedecuesta",
                "Pinchote",
                "Puente Nacional",
                "Puerto Parra",
                "Puerto Wilches",
                "Rionegro",
                "Sabana de Torres",
                "San Andr\u00e9s",
                "San Benito",
                "San Gil",
                "San Joaqu\u00edn",
                "San Jos\u00e9 de Miranda",
                "San Miguel",
                "San Vicente de Chucur\u00ed",
                "Santa B\u00e1rbara",
                "Santa Helena del Op\u00f3n",
                "Simacota",
                "Suaita",
                "Sucre",
                "Surat\u00e1",
                "Tona",
                "Valle de San Jos\u00e9",
                "V\u00e9lez",
                "Vetas",
                "Villanueva",
                "Zapatoca"
            ]
        },
        {  
            "id":27,
            "departamento":"Sucre",
            "ciudades":[  
                "Buenavista",
                "Caimito",
                "Chal\u00e1n",
                "Colos\u00f3",
                "Corozal",
                "Cove\u00f1as",
                "El Roble",
                "Galeras",
                "Guaranda",
                "La Uni\u00f3n",
                "Los Palmitos",
                "Majagual",
                "Morroa",
                "Ovejas",
                "Sampu\u00e9s",
                "San Antonio de Palmito",
                "San Benito Abad",
                "San Juan de Betulia",
                "San Marcos",
                "San Onofre",
                "San Pedro",
                "Sinc\u00e9",
                "Sincelejo",
                "Sucre",
                "Tol\u00fa",
                "Tol\u00fa Viejo"
            ]
        },
        {  
            "id":28,
            "departamento":"Tolima",
            "ciudades":[  
                "Alpujarra",
                "Alvarado",
                "Ambalema",
                "Anzo\u00e1tegui",
                "Armero",
                "Ataco",
                "Cajamarca",
                "Carmen de Apical\u00e1",
                "Casabianca",
                "Chaparral",
                "Coello",
                "Coyaima",
                "Cunday",
                "Dolores",
                "El Espinal",
                "Fal\u00e1n",
                "Flandes",
                "Fresno",
                "Guamo",
                "Herveo",
                "Honda",
                "Ibagu\u00e9",
                "Icononzo",
                "L\u00e9rida",
                "L\u00edbano",
                "Mariquita",
                "Melgar",
                "Murillo",
                "Natagaima",
                "Ortega",
                "Palocabildo",
                "Piedras",
                "Planadas",
                "Prado",
                "Purificaci\u00f3n",
                "Rioblanco",
                "Roncesvalles",
                "Rovira",
                "Salda\u00f1a",
                "San Antonio",
                "San Luis",
                "Santa Isabel",
                "Su\u00e1rez",
                "Valle de San Juan",
                "Venadillo",
                "Villahermosa",
                "Villarrica"
            ]
        },
        {  
            "id":29,
            "departamento":"Valle del Cauca",
            "ciudades":[  
                "Alcal\u00e1",
                "Andaluc\u00eda",
                "Ansermanuevo",
                "Argelia",
                "Bol\u00edvar",
                "Buenaventura",
                "Buga",
                "Bugalagrande",
                "Caicedonia",
                "Cali",
                "Calima",
                "Candelaria",
                "Cartago",
                "Dagua",
                "El \u00c1guila",
                "El Cairo",
                "El Cerrito",
                "El Dovio",
                "Florida",
                "Ginebra",
                "Guacar\u00ed",
                "Jamund\u00ed",
                "La Cumbre",
                "La Uni\u00f3n",
                "La Victoria",
                "Obando",
                "Palmira",
                "Pradera",
                "Restrepo",
                "Riofr\u00edo",
                "Roldanillo",
                "San Pedro",
                "Sevilla",
                "Toro",
                "Trujillo",
                "Tulu\u00e1",
                "Ulloa",
                "Versalles",
                "Vijes",
                "Yotoco",
                "Yumbo",
                "Zarzal"
            ]
        },
        {  
            "id":30,
            "departamento":"Vaup\u00e9s",
            "ciudades":[  
                "Carur\u00fa",
                "Mit\u00fa",
                "Taraira"
            ]
        },
        {  
            "id":31,
            "departamento":"Vichada",
            "ciudades":[  
                "Cumaribo",
                "La Primavera",
                "Puerto Carre\u00f1o",
                "Santa Rosal\u00eda"
            ]
        }
      ];
      
      chMfHolder_gender.querySelector('textarea').style.display = 'none';
      chMfHolder_department.querySelector('textarea').style.display = 'none';
      chMfHolder_city.querySelector('textarea').style.display = 'none';

      chMfHolder_gender.querySelector('.chContent-BPG-group-Value-Label');
      chMfHolder_gender.insertAdjacentHTML('beforeend', `<select type="" title="" name="" id="chMfHolder_gender_select"></select>`);

      chMfHolder_department.querySelector('.chContent-BPG-group-Value-Label');
      chMfHolder_department.insertAdjacentHTML('beforeend', `<select type="" title="" name="" id="chMfHolder_department_select"></select>`);

      chMfHolder_city.querySelector('.chContent-BPG-group-Value-Label');
      chMfHolder_city.insertAdjacentHTML('beforeend', `<select type="" title="" name="" id="chMfHolder_city_select"></select>`);

      // console.log(document.getElementById('chMfHolder_gender_select').value);
      const select_customer_gender = document.getElementById('chMfHolder_gender_select');
      const select_customer_department = document.getElementById('chMfHolder_department_select');
      const select_customer_city = document.getElementById('chMfHolder_city_select');
      
      // Género
      if(gender_customer_options.includes(chMfHolder_gender.querySelector('textarea').value)){
        const index = gender_customer_options.indexOf(chMfHolder_gender.querySelector('textarea').value);
        gender_customer_options.splice(index, 1);
        gender_customer_options.unshift(chMfHolder_gender.querySelector('textarea').value);
      }

      if(chMfHolder_gender.querySelector('textarea').value){
        gender_customer_options.forEach(element => {
          select_customer_gender.insertAdjacentHTML('beforeend', `<option value="${element}">${element}</option>`);
        });
      } else {
        select_customer_gender.insertAdjacentHTML('beforeend', `<option value=""></option>`);
        gender_customer_options.forEach(element => {
          select_customer_gender.insertAdjacentHTML('beforeend', `<option value="${element}">${element}</option>`);
        });
      }
     
      
      select_customer_gender.addEventListener('change', function() {
        const gender_value = select_customer_gender.value;
        chMfHolder_gender.querySelector('textarea').value = gender_value;
      });  

      // Departamento
      chMfHolder_department.querySelector('textarea').value = chMfHolder_department.querySelector('textarea').value.toUpperCase();
      chMfHolder_department.querySelector('textarea').addEventListener('input', function() {
        this.value = this.value.toUpperCase();
      });
      
      if(chMfHolder_department.querySelector('textarea').value){
        colombia.forEach((department, index) => {
          // console.log('ENTRA');
          if(department.departamento.toUpperCase().includes(chMfHolder_department.querySelector('textarea').value)){   
  
            department.ciudades.forEach((city, index) => {
              if(city.toUpperCase().includes(chMfHolder_city.querySelector('textarea').value)){
                let city_selected = city;
                department.ciudades.splice(index, 1);
                department.ciudades.unshift(city_selected);
              }   
            });
            
            let department_selected = colombia[index];
            colombia.splice(index, 1);
            colombia.unshift(department_selected);
          }
        });
      }


      if(chMfHolder_department.querySelector('textarea').value === ""){
        select_customer_department.insertAdjacentHTML('beforeend', `<option value=""></option>`);
      }

      // console.log(colombia);
      colombia.forEach((department) => {
          select_customer_department.insertAdjacentHTML('beforeend', `<option value="${department.departamento.toUpperCase()}">${department.departamento.toUpperCase()}</option>`);
          if(department.departamento.toUpperCase() === department_customer){
            department.ciudades.forEach((city, index) => {
              if(city.toUpperCase().includes(chMfHolder_city.querySelector('textarea').value)){
                let city_selected = city;
                department.ciudades.splice(index, 1);
                department.ciudades.unshift(city_selected);
              }   
            });

            department.ciudades.forEach(city => {
              select_customer_city.insertAdjacentHTML('beforeend', `<option value="${city.toUpperCase()}">${city.toUpperCase()}</option>`);
            });
          }              
      });

      // console.log(colombia);
      if(chMfHolder_department.querySelector('textarea').value === ""){
        select_customer_city.disabled = true;
        document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'gray';
      } else {
        select_customer_city.disabled = false;
        document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'black';
      }

      select_customer_department.addEventListener('change', function() {
        const department_value = select_customer_department.value;
        chMfHolder_department.querySelector('textarea').value = department_value;

        if(chMfHolder_department.querySelector('textarea').value){
          // console.log('TIENE VALOR');
          colombia.forEach((department) => {          
            if(department.departamento.toUpperCase() === department_value){
              select_customer_city.innerHTML = "";
              // select_customer_city.insertAdjacentHTML('beforeend', `<option value=""></option>`);
              department.ciudades.forEach(city => {
                select_customer_city.insertAdjacentHTML('beforeend', `<option value="${city.toUpperCase()}">${city.toUpperCase()}</option>`);
              });
  
              const city_value = select_customer_city.value;
              chMfHolder_city.querySelector('textarea').value = city_value;
            }       
          });
        } 

        if(chMfHolder_department.querySelector('textarea').value === ""){
          select_customer_city.disabled = true;
          document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'gray';
          chMfHolder_city_select.childNodes.forEach(e => {
            // console.log(e);
            e.innerHTML = "";
          });
        }else {
          select_customer_city.disabled = false;          
          document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'black';
        }

      }); 


      select_customer_city.addEventListener('change', function() {
        const city_value = select_customer_city.value;
        chMfHolder_city.querySelector('textarea').value = city_value;
      });


      // Ciudad
      chMfHolder_city.querySelector('textarea').value = chMfHolder_city.querySelector('textarea').value.toUpperCase();
      chMfHolder_city.querySelector('textarea').addEventListener('input', function() {
        this.value = this.value.toUpperCase();
      });

      if(chMfHolder_city){
        chMfFields.appendChild(chMfHolder_city);
      }
    }

  
  });


  // $(function() {
  //   $('.ticker-home').jConveyorTicker();
  //  		anim_duration: 1000
  // });





// (()=>{
//   let menu_hombre_unisex = document.getElementById('mhu');
//   let menu_mujer_unisex = document.getElementById('mmu');
//   let container_info_tallas = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');

//   menu_hombre_unisex.addEventListener('click', (e) => {
//     console.log(container_info_tallas);
//   });

//   menu_mujer_unisex.addEventListener('click', (e) => {
//     console.log(container_info_tallas);
//   });
// })();

// Custom JS 
// ID del filtro por género





// Valida si existe el nombre en el filtro

// var timeToWait;
// var counterFilter = 0; 

// window.addEventListener('load', () => {


// // document.querySelectorAll('#gf-tree .gf-filter-contents .gf-option-block .gf-block-title .h3 span')[3].textContent.indexOf('Tallas'); //True

// // document.querySelectorAll('#gf-tree .gf-filter-contents .gf-option-block .gf-block-title .h3 span')[3].textContent.indexOf('TALLAS'); //False


//   validarURL();
 
//   const globoFilterTree = document.getElementById('gf-tree');


//   globoFilterTree.addEventListener('click', () => {
//     console.log('Click en el globo');

//     clearInterval(timeToWait);    
//     timeToWait = setInterval(validarURL, 100);
//     //validarURL();

   
    
//   });
// });




// var flagInjectionTextFilter = false;

// function validarURL(){
  
//   var url_actual = location.href;
//   var idGenderFilter = '666690';
  
//   var htmlSizeText = `<span id="alertSize" style=" font-size: 13px; padding-top: 6px; padding-left: 16px;">Por favor selecciona tu género.</span>`;
  
//   var textSize = document.querySelector("#gf-tree > div.gf-filter-contents > div.gf-option-block.gf-option-666691.gf-option-block-checkbox.swatch-size-32 > div.gf-block-title");
//   var sizesFilter = document.querySelector("#gf-tree > div.gf-filter-contents > div.gf-option-block.gf-option-666691.gf-option-block-checkbox.swatch-size-32 > div.gf-block-content"); // Contenido del filtro

//   if(url_actual.indexOf(idGenderFilter) == -1 && document.getElementById('alertSize') == null && sizesFilter.style.display != 'none' ){

//     //clearInterval(timeToWait);

//     console.log('La URL no tiene género');
    
//     if(!flagInjectionTextFilter){

//       // var filterTitles = document.querySelectorAll('#gf-tree .gf-filter-contents .gf-option-block .gf-block-title .h3 span');

//       // filterTitles.forEach(
//       //   (e, index)=> {
    
//       //     if(!e.textContent.indexOf('Tallas') || !e.textContent.indexOf('TALLAS')){
//       //       console.log('Tallas está en la posición: ' + index);
//       //       console.log('For Each');
         
//       //     }
    
//       //   }
//       // );

//       // setTimeout(()=>{

//       // }, 1000);
      
//       sizesFilter.style.display = 'none';
//       console.log(sizesFilter);

//       textSize.innerHTML += htmlSizeText;

//       textSize.style.display = 'flex';
//       textSize.style.flexDirection = 'column';

//       flagInjectionTextFilter = true;
//       console.log('FLAG: ');
//       console.log(flagInjectionTextFilter);
//     }
   
//   }else {
    
//     flagInjectionTextFilter = false;
//     console.log('La URL tiene el ID de género');
//     counterFilter+=1;
//     console.log(counterFilter);
//     if(counterFilter > 10 ){
//       clearInterval(timeToWait);
//       counterFilter = 0;
//     }
//   }

//   if(url_actual.indexOf(idGenderFilter) != -1){
//     clearInterval(timeToWait); 
//   }
//  }





// // document.querySelector("#gf-tree > div.gf-filter-contents > div.gf-option-block.gf-option-666691.gf-option-block-checkbox.swatch-size-32 > div.gf-block-content")

// // Si le dio click reviseme el location.search


//  document.addEventListener( 'DOMContentLoaded', ()=> {
        
//       const jibbitz_cart_cross_selling = document.querySelector('#jbz-container .jbz-content__body');
//       const jccsw = document.querySelectorAll('#jbz-container .jbz-content__body .jbz-wrapper');
//       let jccsw_random = Math.floor(Math.random() * jccsw.length);


//       jccsw.forEach((e) => {
//           switch(e.dataset.title){
//             case 'JIBBITZ DE ANIMALES':
//                 console.log('JIBBITZ DE ANIMALES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/animals.png?v=1676913090';                
//             break;
            
//             case 'JIBBITZ DE COMIDA':
//                 console.log('JIBBITZ DE COMIDA');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/food-drink.png?v=1676913090';     
//             break;
            
//             case 'JIBBITZ DE DEPORTES':
//                 console.log('JIBBITZ DE DEPORTES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/sports.png?v=1676913090';
//             break;
            
//             case 'JIBBITZ DE INTERESES Y HOBBIES':
//                 console.log('JIBBITZ DE INTERESES Y HOBBIES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/hobbies-interests.png?v=1676913090';
          
//             break;
            
//             case 'JIBBITZ DE JOYERÍA':
//                 console.log('JIBBITZ DE JOYERÍA');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jewels-metals.png?v=1676913090';
            
//             break;
            
//             case 'JIBBITZ DE LETRAS Y NÚMEROS':
//                 console.log('JIBBITZ DE LETRAS Y NÚMEROS');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/letters_-_numbers.png?v=1677535740';
          
//             break;
            
//             case 'JIBBITZ DE NATURALEZA':
//                 console.log('JIBBITZ DE NATURALEZA');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/flower-nature.png?v=1676913090';
            
//             break;
  
//             case 'JIBBITZ DE PERSONAJES':
//                 console.log('JIBBITZ DE PERSONAJES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/character.png?v=1676913090';
             
//             break;
            
//             case 'JIBBITZ DE SÍMBOLOS':
//                 console.log('JIBBITZ DE SÍMBOLOS');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jibbitz-symbols-sayings.png?v=1676907433';
     
//             break;
//           }
//         if(e.dataset.title !== jccsw[jccsw_random].dataset.title) {
//            e.remove();
//         } else {
//           console.log(e.dataset.title);
//         }
        
//       });
      
//       console.log('JCCS', jibbitz_cart_cross_selling );
//       console.log('JCCSW', jccsw);
//       console.log('JCCSW LENGTH', jccsw.length);
//       console.log('RANDOM', jccsw_random);


//    // Seleccionar el elemento que se desea observar
// var cart_drawer = document.querySelector('cart-drawer');
// var jbz_cross = cart_drawer.querySelector('#jbz-container');
// var cart_drawer_observer_config = { attributes: true, childList: true, subtree: true };

// console.log(cart);
// console.log(jbz_cross);

// if(cart_drawer && jbz_cross){
//   // Crear una instancia del observador de mutación
//   var observer = new MutationObserver(function(mutations) {
//     console.log('OBSERVANDO...');
//     mutations.forEach(function(mutation) {
//       console.log('MUTATION', mutation.target);
//      if (mutation.type === 'childList') {
//       // Realizar acciones en respuesta a los cambios en los hijos del elemento
//       console.log('Se ha producido un cambio en los hijos de jbz-container');

//        jccsw.forEach((e) => {

//          console.log('SWITCH');
//          console.log(e);
//           switch(e.dataset.title){
//             case 'JIBBITZ DE ANIMALES':
//                 console.log('JIBBITZ DE ANIMALES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/animals.png?v=1676913090';                
//             break;
            
//             case 'JIBBITZ DE COMIDA':
//                 console.log('JIBBITZ DE COMIDA');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/food-drink.png?v=1676913090';     
//             break;
            
//             case 'JIBBITZ DE DEPORTES':
//                 console.log('JIBBITZ DE DEPORTES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/sports.png?v=1676913090';
//             break;
            
//             case 'JIBBITZ DE INTERESES Y HOBBIES':
//                 console.log('JIBBITZ DE INTERESES Y HOBBIES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/hobbies-interests.png?v=1676913090';
          
//             break;
            
//             case 'JIBBITZ DE JOYERÍA':
//                 console.log('JIBBITZ DE JOYERÍA');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jewels-metals.png?v=1676913090';
            
//             break;
            
//             case 'JIBBITZ DE LETRAS Y NÚMEROS':
//                 console.log('JIBBITZ DE LETRAS Y NÚMEROS');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/letters_-_numbers.png?v=1677535740';
          
//             break;
            
//             case 'JIBBITZ DE NATURALEZA':
//                 console.log('JIBBITZ DE NATURALEZA');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/flower-nature.png?v=1676913090';
            
//             break;
  
//             case 'JIBBITZ DE PERSONAJES':
//                 console.log('JIBBITZ DE PERSONAJES');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/character.png?v=1676913090';
             
//             break;
            
//             case 'JIBBITZ DE SÍMBOLOS':
//                 console.log('JIBBITZ DE SÍMBOLOS');
//                 e.querySelector('.jbz-wrapper__content .jbz-wrapper__content-img').src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jibbitz-symbols-sayings.png?v=1676907433';
     
//             break;
//           }

         
//         if(e.dataset.title !== jccsw[jccsw_random].dataset.title) {
//            e.remove();
//         } else {
//           console.log(e.dataset.title);
//         }
        
//       });


       
//        observer.disconnect();
//     }

      
//     });
//   });
// }

// observer.observe(jbz_cross, cart_drawer_observer_config);
   
// });



window.addEventListener('load', () => {

  const screenWidth = window.innerWidth;
  
  if (screenWidth <= 991) { 
    // let imagen = document.querySelector('.item-swiper2 .logo-container .logo-banner');
    // imagen.src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/Recurso_2.png?v=1693343579';

    // let swiper_3 = document.querySelector('.item-swiper2 .logo-container .logo-banner');
    // if(swiper_3) {
    //   swiper_3.src = 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/TEXTO_MOB.png?v=1695310716';
    // }     
  }

  // let item_swiper_0 = document.querySelector('.item-swiper0 .swiper-slide__overlay-img-button-container');
  // if(item_swiper_0){
  //     item_swiper_0.insertAdjacentHTML('afterend',`<p style="font-size: 10px; margin: 1% 0 0 0; text-align: center; line-height: 1; color: black;">Válido del 18 hasta el 31 de octubre. <br> *No aplica con otras promociones o cupones de descuento. <br> *Aplica términos y condiciones *No aplica para Jibbitz ni calzado en sale. <br> *El valor de descuento aplicado corresponde al total del valor del producto de menor valor. </p>`);
  // }
  
});




/* Solución provisional para el Newsletter Promo */

// (()=> {

//   const announcementRef = document.querySelector('.announcement-bar__message-link[href="https://crocs.com.co/pages/unete-club-crocs"]');
//   // let bannerRef = document.querySelector('.swiper-slide__link[href="https://crocs.com.co/pages/unete-club-crocs"]');

//   // console.log(announcementRef);
  
//   if(announcementRef){
//     announcementRef.addEventListener('click', (e)=> {
//       e.preventDefault();
//       showModal();
//     });
//   }

//   // if(bannerRef){
    
//   //   bannerRef = bannerRef.parentNode;
//   //   bannerRef.style.cursor = 'pointer'; 

//   //   bannerRef.addEventListener('click', (e)=> {
//   //     e.preventDefault();
//   //     showModal();
//   //   });

//   //   bannerRef = bannerRef.parentNode.querySelectorAll('[href="https://crocs.com.co/pages/unete-club-crocs"]');

//   //   bannerRef.forEach((element, index) => {
//   //     if(index === 1){
//   //       element.style.display = 'none';
//   //     }
//   //   });
//   // }

//   function showModal(){
//     const modal = document.getElementById('modal-newsletter');
//     console.log(modal);
    
//     if(modal) {
//       modal.style.display = 'flex';
//       localStorage.setItem('subscription', 'no');
//     }
//   };

// })();


/** Almacenar el carrito */
sessionStorage.setItem('movedToCheckout', false);


/** Recuperación de Carrito **/


/** Size Chart Conversion **/

(() => {  
  const sizeChart = JSON.parse(localStorage.getItem('sizeChart')).size_chart;  
  const sizes = document.querySelectorAll('.item-talla');
  const sizeLegend = document.getElementById('kt-size-legend');
  const messageSelector = document.querySelector('.kt-size-verification-message');
  const sizeText = document.getElementById('kt-size-text'); 
    
  sizes.forEach((size) => {   
    
    const sizeChartItem = sizeChart.find((item) => item.us.includes(size.dataset.variantValue.trim()) || size.dataset.variantValue.trim().includes(item.us)); 
    if (sizeChartItem !== undefined){
      if (sizeChartItem && sizeChartItem.us.includes(size.dataset.variantValue.trim()) || size.dataset.variantValue.trim().includes(sizeChartItem.us)) {
        size.textContent = sizeChartItem.eu;
      }
    }   
    
    if (size.previousElementSibling.disabled) return;
    
    // Events
    size.addEventListener('click', (event) => {
      const sizeChartItem = sizeChart.find((item) => item.us.includes(size.dataset.variantValue.trim()));
      if(sizeChartItem !== undefined){
        if (sizeChartItem && sizeChartItem.us.includes(size.dataset.variantValue.trim())) {    
          const message = `Talla ${sizeChartItem.eu.replace('-', ' / ')} EUR:`;
          const messageSize = `Talla ${sizeChartItem.eu.replace('-', ' / ')} | Largo del pie: ${sizeChartItem.cm} cm`;
          messageSelector.classList.add('show');
          sizeLegend.innerHTML = message;
          sizeText.textContent = messageSize;
  
          sizeLegend.classList.remove('highlight-bold');
          void sizeLegend.offsetWidth; 
          sizeLegend.classList.add('highlight-bold');
        }
      }
    });
  }); 
})();